import { createAsyncThunk } from "@reduxjs/toolkit";
import { commitmentsTypeTabSelector } from "../../selectors/common/commitmentsTypeTabSelector";
import { commitmentsCurrentOrgProviderSelector } from "../../selectors/common/commitmentsCurrentOrgProviderSelector";
import { getAWSReservationsForDataGridThunk } from "../reservations/getAWSReservationsForDataGridThunk";
import { RootState } from "@/store/store";
import { getAzureReservationsForDataGridThunk } from "@/store/commitments/thunks/azure/reservations/getAzureReservationsForDataGridThunk";
import { getAzureSavingsPlansForDataGridThunk } from "@/store/commitments/thunks/azure/saving-plans/getAzureSavingsPlansForDataGridThunk";
import { getAWSSavingsPlansForDataGridThunk } from "@/store/commitments/thunks/savings-plans/getAWSSavingsPlansForDataGridThunk";

export const refetchCommitmentsDataByTabAndProviderThunk = createAsyncThunk(
  "commitments/refetchCommitmentsDataByTabAndProvider",
  async (_: void, { dispatch, getState }) => {
    const state = getState() as RootState;
    const activeTab = commitmentsTypeTabSelector(state);
    const provider = commitmentsCurrentOrgProviderSelector(state);

    if (activeTab === "reservation") {
      const thunk =
        provider === "azure"
          ? getAzureReservationsForDataGridThunk
          : getAWSReservationsForDataGridThunk;

      dispatch(thunk());
    } else {
      const thunk =
        provider === "azure"
          ? getAzureSavingsPlansForDataGridThunk
          : getAWSSavingsPlansForDataGridThunk;

      dispatch(thunk());
    }
  },
);
